import styled from 'styled-components';

export const BigImage = styled.img`
    border-radius: 6px;
    width: 728px;
    height: 90px;
    @media screen and (max-width: 690px) {
        width: 100%;
        height: auto;
    }
`;

export const Label = styled.p`
    text-align: center;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    opacity: .87;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    margin: ${({ theme }) => theme.spacing * 6}px;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

